export default "__VITE_ASSET__ng5n0Wtj__"